import gql from "graphql-tag";

export default gql`
  query getUserById($userId: Int!) {
    userById(id: $userId) {
      id
      email
      firstname
      lastname
      emailVerified
      identityVerified
      verificationLevel
      averageRating
      totalReviews
      totalSales
      profilePictureUrl
      createdAt
    }
  }
`;
